<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">学术订阅</span>
        <a href="javascript:;" class="gl_pad_btn gl_pad_btn_active marginLeft10">免费订阅</a>
      </div>
    </div>
    <div class="display_between marginTop20">
      <div class="tipBlock display_center">
        <div class="imgBlock display_center">
          <img src="/image/geren/imgbg1.png" class="bgimg">
          <img src="/image/geren/imgtop4.png">
        </div>
        <div class="marginLeft20">
          <p class="fontsize18 fontBold">课程</p>
          <p class="fontsize12 grayColor">专业的课堂知识体验</p>
        </div>
      </div>
      <div class="tipBlock display_center">
        <div class="imgBlock display_center">
          <img src="/image/geren/imgbg2.png" class="bgimg">
          <img src="/image/geren/imgtop7.png">
        </div>
        <div class="marginLeft20">
          <p class="fontsize18 fontBold">资讯</p>
          <p class="fontsize12 grayColor">全面的资讯信息展示</p>
        </div>
      </div>
      <div class="tipBlock display_center">
        <div class="imgBlock display_center">
          <img src="/image/geren/imgbg3.png" class="bgimg">
          <img src="/image/geren/imgtop3.png">
        </div>
        <div class="marginLeft20">
          <p class="fontsize18 fontBold">文献</p>
          <p class="fontsize12 grayColor">丰富的文献杂志信息</p>
        </div>
      </div>
    </div>

    <div class="footerBlock display_flex marginTop30">
      <div class="ftitle">一键开启</div>
      <div class="rightF display_flex">
        <div style="margin-left: 60px;">
          <p><img src="/image/geren/lv14.png">一个关键词，订阅三类内容</p>
          <p><img src="/image/geren/lv14.png">每周更新</p>
          <p><img src="/image/geren/lv14.png">按周订阅，每周一推送内容</p>
        </div>
        <div style="margin-left: 60px;">
          <p><img src="/image/geren/lv14.png">按月订阅，每月1日或15日推送内容</p>
          <p><img src="/image/geren/lv14.png">可随时取消</p>
        </div>
      </div>
    </div>
    <div class="text_center marginTop50">
      <!-- <a href="userSubscribeOpera" class="confirmBtn">确认</a> -->
      <router-link class="confirmBtn"   :to="{name:'userSubscribeOpera'}">开始订阅</router-link>
    </div>
  </div>

</template>

<script>
export default {
  name: "userSubscribe",
  data() {
    return {
      AuthorId: ''
    }
  },
  methods: {
    //查询订阅信息
    GetSubscriptionInfoList() {
      let _this = this
      _this.httphelper.post('/api/SubscriptionApi/GetSubscriptionInfoList', {
        "id": 0,
        "lablename": "",
        "frequency": 0,
        "pushemail": "",
        "isFirstSubscript": 0,
        "userid": Number(this.AuthorId), //用户ID
        "username": "",
        "status": 0
      }).then(res => {
        if (res.data.code == 200) {
          if (res.data.data != null && res.data.data.id > 0) {
            this.$router.push({
              path: 'userSubscribeMenu?'
            });
          }
          else {
            this.$router.push({
              path: 'userSubscribe',
            });
          }
        }
      });
    },
  },
  mounted() {
     
    //获取用户信息
    if (localStorage.getItem('ResData')) {
      let resdata = JSON.parse(localStorage.getItem('ResData'))
      this.AuthorId = resdata.id
    }
    //1.先根据用户id查询，是否第一次订阅
    this.GetSubscriptionInfoList();
    //2.如果第一次订阅，则提交订阅信息
    //3.否则，直接显示订阅列表

  }
}
</script>

<style scoped>
.tipBlock {
  width: 300px;
  height: 147px;
  background: rgba(255, 255, 255, 0);
  box-shadow: 3px 5px 10px 0px rgba(0, 0, 0, 0.06);
}
.imgBlock {
  width: 64px;
  height: 65px;
  position: relative;
}
.bgimg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
.footerBlock {
  padding: 16px 0;
  background-color: #e8ebf0;
}
.ftitle {
  padding: 50px 0;
  width: 206px;
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  border-right: 1px solid #ccc;
}
.rightF p {
  line-height: 40px;
}
.rightF img {
  vertical-align: -3px;
  margin-right: 8px;
}
.confirmBtn {
  width: 200px;
  height: 40px;
  background: #0b8586;
  border-radius: 20px;
  display: inline-block;
  text-align: center;
  line-height: 40px;
  color: #fff;
}
</style>
